module.exports = __webpack_public_path__ + "img/luxuryyacht_option_03.048bf597.jpg";